import { type FocusEvent, useState } from "react";
import { IMask, useIMask } from "react-imask";

import { BaseInput } from "src/components/ExerciseAttributeBaseInput";
import {
  type MaskedAttributeInputProps,
  useMaskedInputRegistryCleanup,
} from "src/workouts/exerciseAttributeInput.shared";

export function MinutesMaskedInput(props: MaskedAttributeInputProps) {
  useMaskedInputRegistryCleanup(props.registryHandlers);

  const [opts] = useState({
    mask: "MM:SS",
    overwrite: true,
    lazy: false,
    autofix: true,
    blocks: {
      MM: {
        mask: IMask.MaskedRange,
        from: 0,
        to: 59,
        placeholderChar: "0",
      },
      SS: {
        mask: IMask.MaskedRange,
        from: 0,
        to: 59,
        placeholderChar: "0",
      },
    },
  });

  const iMask = useIMask(opts, {
    defaultValue: props.defaultValue,
    onAccept: (value) => {
      props.onAccept(value);
    },
  });

  function setInputRef(ref: HTMLInputElement | null) {
    iMask.ref.current = ref;
  }

  function handleFocus(event: FocusEvent<HTMLInputElement>) {
    props.registryHandlers.onFocus(event.currentTarget);
  }

  function handleBlur(event: FocusEvent<HTMLInputElement>) {
    props.registryHandlers.onBlur(event.currentTarget);
  }

  return (
    <BaseInput
      disabled={props.disabled}
      onBlur={handleBlur}
      onFocus={handleFocus}
      ref={setInputRef}
    />
  );
}
